
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/view-profile/[customer-id]",
      function () {
        return require("private-next-pages/view-profile/[customer-id]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/view-profile/[customer-id]"])
      });
    }
  